import { action, observable } from 'mobx';
import stores from '../../../models/Stores';
import MapImageLayer from '@arcgis/core/layers/MapImageLayer';
import { FeatureSet } from 'cd-eft/utils/esriTypes';
import { MapView } from 'cd-eft/utils/esriTypes';
import { resetMap } from 'cd-eft/components/SurveyEngineering/Maps/SETMapFunctions/mapOperations';
import { DesignContainerVM } from 'cd-eft/components/Design/DesignContainer/DesignContainerVM';
import MessageCenter from 'cd-eft/components/common/MessageCenter/MessageCenterVM';

import * as SETAPI from 'cd-eft/services/eftSetApi';
import { DesignElementResponse } from 'cd-eft/_codegen_/openapi-generator/eft-set';
import { appConfig } from 'cd-eft/config/AppConfig';
import { EngineeringMapService } from 'cd-eft/framework/mapServices/EngineeringMapServices';
import { INotification } from 'cd-eft/models/Stores/DesignStore';


const { pitDesignStore, designStore, projectsLibraryStore } = stores.AppStore;
const setStore = stores.AppStore.surveyEngineeringStore;
const gisModel = stores.AppStore.surveyEngineeringStore.gisModel;

export class PitSummaryVM {
  @observable props;
  @observable inputRef;
  @observable isLoading: boolean = false;
  @observable jobExecuting: boolean = false;
  @observable jobMessage: string = '';
  @observable mapServiceLayer: any = MapImageLayer;
  @observable output_ground_points: any = FeatureSet;
  @observable notification: INotification = {
    message: '',
    header: '',
    type: '',
    hidden: true,
    timestamp: undefined,
  };
  @observable error = false;
  @observable errorMsg = '';
  @observable selectDisplayPits = false;
  @observable selectSurface = false;
  @observable displayType = 'none';
  @observable somePitSelected = false;
  @observable selectedPitsInfo: any = [];

  private mapView?: MapView;
  constructor(props: any, inputRef) {
    this.props = props;
    this.inputRef = inputRef;
    if (props.mapView) {
      this.mapView = props.mapView;
    }
  }

  @action.bound clearNotification(): void {
    this.notification = { message: '', header: '', type: '', hidden: true, timestamp: undefined };
  }

  @action.bound statusCallback(jobInfo: __esri.JobInfo) {
    let messageIndex = 0;
    if (jobInfo && jobInfo.messages && jobInfo.messages.length > 0) {
      if (jobInfo.messages) {
        if (jobInfo.messages.length > messageIndex)
          for (let i = messageIndex; i < jobInfo.messages.length; i++) {
            // console.log(jobInfo.messages[i].description);
            this.jobMessage = jobInfo.messages[i].description;
          }
        messageIndex = jobInfo.messages.length;
      }
    }
  }
  @action.bound async onClickSurface() {
    resetMap();
    designStore.hideCrossSectionToolbar = true;
    designStore.hideSingleCrossSection = true;
    pitDesignStore.showLoader = true;

    pitDesignStore.displayedPitsIds = [];

    this.selectedPitsInfo.forEach((pad) => {
      pitDesignStore.displayedPitsIds.push(pad.designElementId)
    });

    const input_structure_json_ids: number[] = pitDesignStore.displayedPitsIds.map((item) => {
      return item as number;
    });
    let i = 0;
    while (i < pitDesignStore.pitLayers.length) {
      const layer = pitDesignStore.pitLayers[i];
      const status = input_structure_json_ids.findIndex((id) => id.toString() === layer.id);
      if (status === -1) {
        pitDesignStore.pitLayers.splice(status, 1);
      } else {
        i++;
      }
    }
    try {
      if (0 < input_structure_json_ids.length) {
        await DesignContainerVM.loadMultiStructureSurface(input_structure_json_ids);
      } else {
        await DesignContainerVM.displayOriginalSurface();
      }
      pitDesignStore.latestElementId = undefined;
      setStore.pointsOnMap = false;
      this.mapView!.ui.add(gisModel.locationWidget, 'bottom-left');
    } catch (error) {
      MessageCenter.addError((error as Error).message);
    } finally {
      setTimeout(() => {
        setStore.isLoading = false;
      }, 1000);
    }
    pitDesignStore.showLoader = false;
  }

  @action.bound async getDesignElements() {
    pitDesignStore.pitSummaryTable = [];
    this.selectedPitsInfo = [];
    designStore.designElementId = 0;
    pitDesignStore.showLoader = true;
    designStore.designElementTypeId = appConfig.hardCodes.designElementTypePitRectangular //To enable ToolBar on the map for Pit
    const sessionId = designStore.projectsStore.currentSessionId;
    if (!sessionId) {
      pitDesignStore.showLoader = false;
      return;
    }
    const structureList = 'Pit-Rectangular,Pit-Round,Pit-Diked';

    try {
      const response = await SETAPI.DesignElementController.getAllDesignElementsBySessionAndTypeUsingGET(
        sessionId,
        structureList
      );

      if (response && response.data) {
        let data: any = response.data;
        pitDesignStore.pitSummaryTable = [];

        //pit structures
        data = data.filter(e => e.designElementTypeId === appConfig.hardCodes.designElementTypePitRectangular || e.designElementTypeId === appConfig.hardCodes.designElementTypePitRound || e.designElementTypeId === appConfig.hardCodes.designElementTypePitDiked)
        data.map((item) => this.mapIdToName(item));
        data.map((item, index) => {
          item.checked = false;
        });

        pitDesignStore.pitSummaryTable.push(...data);

        // data.forEach((item, index) => {
        //   const selected = pitDesignStore.selectedPitsInfo.find((pit) => {
        //     return pit.designElementId === item.designElementId;
        //   });
        //   if (selected) {
        //     const e = {
        //       target: {
        //         checked: true,
        //       },
        //     };
        //     this.handleCheckboxChange(e, index);
        //   }
        // })
        data.map((item, index) => {
          if (
            pitDesignStore.pitLayers.some((layer) => {
              return layer.id === `${item.designElementId}`;
            })
          ) {
            const e = {
              target: {
                checked: true,
              },
            };
            this.handleCheckboxChange(e, index);
          }
        });

        pitDesignStore.showLoader = false;
      }
    } catch (err) {
      pitDesignStore.showLoader = false;
      console.error(err);
      this.error = true;
      this.errorMsg = `Uh oh - something went wrong. ${err}`;
    }
  }

  @action.bound mapIdToName(item) {
    switch (item.designElementTypeId) {
      case 11:
        item.designElementTypeId = {
          name: 'Rectangular Pit',
          id: 11,
        };
        break;
      case 12:
        item.designElementTypeId = {
          name: 'Round Pit',
          id: 12,
        };
        break;
      case 13:
        item.designElementTypeId = {
          name: 'Diked Pit',
          id: 13,
        };
        break;
      default:
        return;
    }
  }
  @observable elementActions = {
    Edit: { action: this.openSinglePit },
    Delete: { action: this.deleteDesignElement },
  };

  @action.bound parseAndConvert(data: DesignElementResponse): void {
    if (data.json === undefined || data.designElementId === undefined) {
      throw new Error('invalid input at parseAndConvert');
    }
    let parsedData = JSON.parse(data.json);
    const roundDikedData = JSON.parse(data.json); // This needs to be a separate structure for newPitResults from newDesignForm (keeping slope vs slopes)
    // The two manipulations for Round and Diked pits are needed for the tsx referenced values
    if (data.designElementTypeId === 12) {
      // if editing round pit we need to convert slope slopes array so NewPit works
      const { slope, ...rest } = parsedData;
      parsedData = { slopes: [slope], ...rest };

    }
    // if editing Diked pit we need to set these as they have different values from BE
    if (data.designElementTypeId === 13) {
      parsedData.bottomWidth = parsedData.width;
      parsedData.bottomLength = parsedData.length;
      parsedData.bottomElevation = parsedData.center.z;
      parsedData.pitDepth = parsedData.topElevation - parsedData.center.z;
    }

    pitDesignStore.newDesignForm = parsedData;
    if (data.designElementTypeId === 11) {
      pitDesignStore.newPitResults = parsedData;
    } else {
      // the original response is the right format for the pit API calls
      pitDesignStore.newPitResults = roundDikedData;
    }
    pitDesignStore.newDesignForm.designElementId = data.designElementId;
  }

  @action.bound async openSinglePit(event, item) {
    const id = item.designElementId;
    try {
      const response = await SETAPI.DesignElementController.surveyDesignElementByIdUsingGET(id);
      const data: DesignElementResponse[] = response['data'];
      if (data[0] && this.mapView) {
        this.parseAndConvert(data[0]);
        pitDesignStore.pendingEdits = { name: false, design: false, unsavedEdits: true };
        pitDesignStore.hasDesign = true;
        pitDesignStore.editDesign = true;
        pitDesignStore.showLoader = true;
        pitDesignStore.currentTab = 'New Pit';
        const index = pitDesignStore.pitSummaryTable.findIndex((pit) => {
          return pit.designElementId === id
        });
        if (index !== -1) {
          pitDesignStore.pitSummaryTable[index].checked = true;
          this.selectedPitsInfo.push(pitDesignStore.pitSummaryTable[index]);
        }
        const layerIndex = pitDesignStore.pitLayers.findIndex((layer) => layer.id === id.toString());
        if (layerIndex !== -1) {
          this.mapView.map.remove(pitDesignStore.pitLayers[layerIndex]);
          pitDesignStore.pitLayers.splice(layerIndex, 1);
        }
        pitDesignStore.addPitToMap(pitDesignStore.newPitResults, this.mapView, true, projectsLibraryStore.projectSpatialReference!, id);
        pitDesignStore.originalDesignLayer = pitDesignStore.currentDesignLayer;
        pitDesignStore.originalPitResults = pitDesignStore.newPitResults;
        pitDesignStore.originalIdString = id;
        designStore.structureLayerExists = true;
      }
    } catch (err) {
      console.error(err);
    }
  }

  @action.bound handleCheckboxChange(e: any, index, updateArray?: boolean) {
    // console.log('handleCheckboxChange:', e, index);
    pitDesignStore.pitSummaryTable[index].checked = e.target.checked;
    if (e.target.checked) {
      this.selectedPitsInfo.push(pitDesignStore.pitSummaryTable[index]);
    } else {
      this.selectedPitsInfo.replace(
        this.selectedPitsInfo.filter((p, j) => {
          return !(p === pitDesignStore.pitSummaryTable[index]);
        })
      );
    }

    this.somePitSelected = this.selectedPitsInfo.length > 0 ? true : false;
    // this is too slow, need to optimize DisplaySelectedPits before uncommenting
    // this.displaySelectedPits();

    // if (updateArray) pitDesignStore.selectedPitsInfo = this.selectedPitsInfo;
  }

  @action.bound displaySelectedPits() {
    pitDesignStore.selectedPitsInfo = this.selectedPitsInfo;
    if (this.props.applyPitStructuresToMap) {
      this.props.applyPitStructuresToMap();
      // console.log(pitDesignStore.selectedPitsInfo);
      //console.log(this.props.applyPitStructuresToMap);
    }
  }

  @action.bound async deleteDesignElement(event, item) {
    console.warn('delete n single pit item=', item);
    pitDesignStore.showLoader = true;
    const designElementId = item.designElementId;
    try {
      await SETAPI.DesignElementController.deleteDesignElementUsingPOST(designElementId);
      if (designElementId === pitDesignStore.latestElementId) {
        await DesignContainerVM.displayOriginalSurface();
        pitDesignStore.latestElementId = undefined;
      }
      const layerIndex = pitDesignStore.pitLayers.findIndex((layer) => layer.id === designElementId.toString());
      if (layerIndex !== -1) {
        if (this.mapView) this.mapView.map.remove(pitDesignStore.pitLayers[layerIndex]);
        pitDesignStore.pitLayers.splice(layerIndex, 1);
      }
      // removeLayers([padDesignStore.currentDesignLayer], this.mapView!);
      const layer = this.mapView!.map.findLayerById(designElementId.toString())
      if (layer) {
        this.mapView!.map.remove(layer)
      }
      const map = EngineeringMapService.instance?.mapView?.map;
      designStore.removeDesignedContours(map);
      await this.getDesignElements();

      // prepare displayed pits
      const index = pitDesignStore.displayedPitsIds.indexOf(designElementId);
      if (index >= 0) {
        pitDesignStore.displayedPitsIds.splice(index, 1);
      }

      const rest_structure_json_ids: number[] = pitDesignStore.displayedPitsIds.map((id) => {
        return id;
      });
      if (0 < rest_structure_json_ids.length) {
        await DesignContainerVM.loadMultiStructureSurface(rest_structure_json_ids);
      }
      if (pitDesignStore.pitSummaryTable.length == 0) {
        await DesignContainerVM.displayOriginalSurface();
        pitDesignStore.latestElementId = undefined;
        pitDesignStore.displayedPitsIds = [];
      }
    } catch (e) {
      console.warn('deleteDesignElement error = ', e);
    } finally {
      if (this.mapView && !designStore.hideSingleCrossSection) await designStore.validateSingleCrossSection(this.mapView);
    }
  }
  @action.bound addPit() {
    pitDesignStore.currentTab = 'New Pit';
    pitDesignStore.showLoader = true;
    pitDesignStore.hasDesign = true;
    designStore.onNewStructureTab = true;
  }
}
